import { getAuth, sendPasswordResetEmail, updateProfile } from "@firebase/auth";
import React, { useEffect, useId, useState } from "react";
import GetUser from "../../Controllers/Users/GetUser";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
export const ProfileViewModal = () => {
  const [CurrentAuth, setCurrentAuth] = useState({});
  const [ProfileImage, setProfileImage] = useState();
  const [refresh, setRefresh] = useState(true);
  const [ButtonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (ProfileImage) {
      UploadFile(ProfileImage);
    }
  }, [ProfileImage]);

  const UploadFile = async (ProfileImage) => {
    setButtonLoader(true);
    const storage = getStorage();

    let __ext = ProfileImage.name.split(".").pop();

    let path = `profile_img/${getAuth().currentUser.uid}/profile.${__ext}`;

    const ProfileImgRef = ref(storage, path);
    uploadBytes(ProfileImgRef, ProfileImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        updateProfile(getAuth().currentUser, {
          photoURL: url,
        }).then(() => {
          let UserRef = doc(db, "Users", getAuth().currentUser.uid);
          setDoc(UserRef, { photoURL: url }, { merge: true })
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
          setRefresh(!refresh);
          setButtonLoader(false);
        });
      });
    });
  };

  //  Change password state
  const [email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState(false);
  const [IsCheckError, setIsCheckError] = useState(false);
  const [IsPasswordResetEmailSend, setIsPasswordResetEmailSend] = useState();

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setCurrentAuth(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, email]);

  // Check email validation
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const UIErrorHandling = () => {
    let flag = 0;
    if (
      email === "" ||
      email === null ||
      email === undefined ||
      !isValidEmail(email)
    ) {
      setEmailError(true);
      flag++;
    } else {
      setEmailError(false);
    }
    return flag;
  };
  const ResetPassword = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      let auth = getAuth();
      sendPasswordResetEmail(auth, email)
        .then(() => {
          setIsPasswordResetEmailSend(true);
          return;
        })
        .catch((err) => {
          setIsPasswordResetEmailSend(false);
        });
    }
  };

  return [
    CurrentAuth,
    email,
    setEmail,
    ResetPassword,
    EmailError,
    IsPasswordResetEmailSend,
    ProfileImage,
    setProfileImage,
    refresh,
    ButtonLoader,
  ];
};

export default ProfileViewModal;
